import { FulfillmentProvidersSettings } from './fulfillment-providers-settings';
import { useIsDropShipEnabledForSeller } from '../../../hooks/use-is-dropship-add-on-enabled';

export const FulfillmentProvidersSettingsLoader = () => {
  const shouldShowVendorTab = useIsDropShipEnabledForSeller();

  return <FulfillmentProvidersSettings shouldShowVendorTab={shouldShowVendorTab} />;
};
